export default __webpack_public_path__ + "static/media/graph.31234ca1.png";